import React from 'react';
import styled from 'styled-components';
import BasicContainer from '../../Components/Bord/BasicContainer';
import MediaQuery from 'react-responsive'

import logo_white from '../../Components/Template/Images/logo_white.svg';
import sns_icon1 from '../../Images/sns_icon1.svg'
import sns_icon2 from '../../Images/sns_icon2.svg'
import sns_icon3 from '../../Images/sns_icon3.svg'
import sns_icon4 from '../../Images/sns_icon4.svg'

import LITEPAPER from '../../whitepaper/LITEPAPER.pdf';

const Line = styled.div`
  width: 100%;
  border-top: 1px solid #fff;
`
const ContentContainer = styled.div`
  margin-top: 100px;
  width: 100%;
  display: flex;
  @media (max-width: 900px) {
    flex-direction: column;
  };
`
const ImgContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  & > img {
    margin-left: auto;
    width: 120px;
  }
  @media (max-width: 900px) {
    margin-left: 0;
    & > img {
      margin-left: 0;
    }
  };
`
const TextContainer = styled.div`
  & > p {
      font-weight: 100;
      font-size: 15px;
      line-height: 200%;
      color: #FFFFFF;
    }
  & > p:nth-child(1) {
    font-weight: 600;
    @media (max-width: 900px) {
      margin-top: 30px;
    };
  }
`
const SnsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  & > div {
    & > img {
      cursor: pointer;
      width: 30px;
    }
  }
  & > div + div {
    margin-left: 10px;
  }
`
const Button = styled.button`
  margin-top: 10px;
  width: 140px;
  height: 30px;
  background-color: #FF8E00;
  color: white;
  font-size: 13px;
  cursor: pointer;
`
const BottomContainer = ({ language }) => {
  return (
    <BasicContainer
      bgColor={'#080B31'}
      style={{ paddingTop: 80, paddingBottom: 240 }}
    >
      <Line />
      <ContentContainer>
        <MediaQuery maxWidth={900}>
          <ImgContainer>
            <img alt='' src={logo_white} />
            <SnsContainer>
              <div>
                <img alt="" src={sns_icon1} />
              </div>
              <div>
                <img alt="" src={sns_icon2} />
              </div>
              <div>
                <img alt="" src={sns_icon3} />
              </div>
              <div>
                <img alt="" src={sns_icon4} />
              </div>
            </SnsContainer>
          </ImgContainer>
        </MediaQuery>
        <TextContainer>
          <p>ANGERLABS BY GRIPFAN + PIGBOX</p>
          <p>Copyright ⓒ AngerLabs. All rights reserved.</p>
          <Button
            onClick={() => {
              window.open(language === 'Korean' ? LITEPAPER : LITEPAPER);
            }}>
            LITEPAPER
          </Button>
        </TextContainer>
        <MediaQuery minWidth={900}>
          <ImgContainer>
            <img alt='' src={logo_white} />
            <SnsContainer>
              <div>
                <img alt="" src={sns_icon1} />
              </div>
              <div>
                <img alt="" src={sns_icon2} />
              </div>
              <div>
                <img alt="" src={sns_icon3} />
              </div>
              <div>
                <img alt="" src={sns_icon4} />
              </div>
            </SnsContainer>
          </ImgContainer>
        </MediaQuery>
      </ContentContainer>
    </BasicContainer>
  )
}

export default BottomContainer;